import { instance } from "libs/api";

export interface AuditMediaSummary {
  id: string;
  url: string;
}

export const requestGetMediaByIds = async (
  ids: string[]
): Promise<AuditMediaSummary[]> => {
  return await instance.post("media/by-ids", { ids });
};
